import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabPanelsComponent } from './tab-panels.component';

@NgModule({
  declarations: [TabPanelsComponent],
  imports: [CommonModule],
  exports: [TabPanelsComponent],
})
export class TabPanelsModule {}
